import React from "react";
import { SymbolComponentType } from "../helpers/getSymbol";

const CoursePointer2 = (props: SymbolComponentType) => {
  const { index, attributes, transformStr } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.104153 9.2434324"
      key={index}
      id={`symbol-${index}`}
      tabIndex={0}
      className="symbol target"
      name="symbol"
      preserveAspectRatio="xMidYMid meet"
      style={{
        top: `${attributes.top}%`,
        left: `${attributes.left}%`,
        width: `${attributes.width}%`,
        height: `${attributes.height}%`,
        zIndex: attributes.zIndex,
        // transform:`rotate(${attributes?.transform?.rotate}deg) scaleX(${attributes?.transform?.scaleX}) scaleY(${attributes?.transform?.scaleY}) matrix3d(${attributes?.transform?.matrix3d})`
        transform: transformStr,
      }}
    >
      <path
        stroke={`${attributes.borderColor || "white"}`}
        fill={`${attributes?.backgroundColor || "transparent"}`}
        strokeWidth={`${attributes.lineWidth || 0.1}`}
        // className="selected_course_pointer_1"
        d="M 12.58,0.56 8.56,0.8 4.15,3.11 3.36,1.54 1.52,2.47 2.32,4.06 0.68,4.92 2.28,7.93 3.85,7.11 4.77,8.94 6.61,8.02 5.68,6.15 10.16,3.81 Z"
      />
    </svg>
  );
};

export default CoursePointer2;
